import React from "react";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";
import { InputAdornment, styled } from "@mui/material";
import { UnderlinedInput } from "./UnderlinedInput";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, value, ...other } = props;

  return (
    <IMaskInput
      mask={Number}
      radix="."
      thousandsSeparator=","
      scale={0}
      unmask
      inputRef={ref}
      value={value.toString()}
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      {...other}
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const InputAdornmentStyled = styled(InputAdornment)({
  marginRight: "5px",
});

export const MoneyUnderlinedInput = ({ max, min, ...props }) => {
  return (
    <UnderlinedInput
      {...props}
      className="money-input"
      InputProps={{
        inputComponent: NumericFormatCustom,
        startAdornment: (
          <InputAdornmentStyled
            className="date-picker-icon-mobile-wrapper"
            position="start"
          >
            $
          </InputAdornmentStyled>
        ),
      }}
    />
  );
};
